import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { MarkerService } from '../../../../services/marker.service';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-update-location',
  standalone: true,
  imports: [ButtonModule, CommonModule],
  templateUrl: './update-location.component.html',
  styleUrl: './update-location.component.css',
})
export class UpdateLocationComponent {
  isUpdatingLocation!: boolean;
  $spinner!: Observable<any>;

  constructor(private markerService: MarkerService) {
    this.$spinner = this.markerService.$spinner;
  }

  async updateCustomerLocation() {
    try {
      console.log('ATTEMPTING TO UPDATE CUSTOMER LOCATION');
      this.markerService.updateSpinnerSubject(true);
      const geoLocation = new Promise(() => this.markerService.updateMemberLocationFromGeoLocation())
      await geoLocation
    } catch (error) {
      this.markerService.updateSpinnerSubject(false);
      console.error('Location update failed:', error);
    } 
  }
}
